import script from "./UpgradesShop.vue?vue&type=script&setup=true&lang=js"
export * from "./UpgradesShop.vue?vue&type=script&setup=true&lang=js"

import "./UpgradesShop.vue?vue&type=style&index=0&id=909bd766&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-909bd766"]])

export default __exports__